import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { LimitCategoryTypes } from "@data-types";
import { DepositContext } from "@state/context/payment/DepositContext";
import { LimitType } from "@utils/limits/limitType";
import { observer } from "mobx-react";

import DepositLimitIncreaseTermsCheckbox from "./DepositLimitIncreaseTermsCheckbox";
import DepositLimitMonthlyDepositLimit from "./DepositLimitMonthlyDepositLimit";
import DepositLimitMonthlyLossLimit from "./DepositLimitMonthlyLossLimit";

export default observer(function DepositLimitMonthlyLimit() {
	const depositStore = useContext(DepositContext);

	const { t } = useTranslation("my-limits");

	if (
		depositStore.depositLimitStore.limitData?.userLimits[0]
			?.gamingLimitDuration.abrv !== LimitType.MONTHLY_LIMIT
	) {
		return null;
	}

	return (
		<>
			<div className="title--secondary">
				{t("MONTHLY_DEPOSIT_AND_LOSS_LIMITS")}
			</div>

			<div className="form__group">
				<div className="form--grid__row row">
					<DepositLimitMonthlyDepositLimit
						type={
							(depositStore.depositLimitStore.limitData
								?.userLimits[0]?.gamingLimitCategory
								.abrv as LimitCategoryTypes) ||
							LimitCategoryTypes.SPORTS_BETTING
						}
					/>

					<DepositLimitMonthlyLossLimit
						type={
							(depositStore.depositLimitStore.limitData
								?.userLimits[1]?.gamingLimitCategory
								.abrv as LimitCategoryTypes) ||
							LimitCategoryTypes.SPORTS_BETTING
						}
					/>

					<DepositLimitIncreaseTermsCheckbox
						amount={
							depositStore.depositLimitStore.limitData
								?.userLimits[0]?.amount
						}
						type={
							(depositStore.depositLimitStore.limitData
								?.userLimits[0]?.gamingLimitCategory
								.abrv as LimitCategoryTypes) ||
							LimitCategoryTypes.SPORTS_BETTING
						}
					/>
				</div>
			</div>
		</>
	);
});
